var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2838.05 2800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d4ecff;}.cls-2{fill:#396caa;}.cls-3{fill:#91b3fa;}.cls-4{fill:#699dd1;}.cls-5{fill:#7d97f4;}.cls-6{fill:#bdd0fb;}.cls-7{opacity:0.8;}.cls-8,.cls-9{fill:#fff;}.cls-9{opacity:0.81;}.cls-10{fill:url(#linear-gradient);}.cls-11{fill:url(#linear-gradient-2);}.cls-12{fill:url(#linear-gradient-3);}.cls-13{fill:url(#linear-gradient-4);}.cls-14{fill:url(#linear-gradient-5);}.cls-15{fill:url(#linear-gradient-6);}.cls-16{fill:url(#linear-gradient-7);}.cls-17{fill:url(#linear-gradient-8);}.cls-18{fill:url(#linear-gradient-9);}.cls-19{fill:url(#linear-gradient-10);}.cls-20{fill:url(#linear-gradient-11);}.cls-21{fill:url(#linear-gradient-12);}.cls-22{fill:url(#linear-gradient-13);}.cls-23{fill:url(#linear-gradient-14);}.cls-24{fill:url(#linear-gradient-15);}.cls-25{fill:url(#linear-gradient-16);}.cls-26{fill:url(#linear-gradient-17);}.cls-27{fill:url(#linear-gradient-18);}.cls-28{fill:url(#linear-gradient-19);}.cls-29{fill:url(#linear-gradient-20);}.cls-30{fill:url(#linear-gradient-21);}.cls-31{fill:url(#linear-gradient-22);}.cls-32{fill:url(#linear-gradient-23);}.cls-33{fill:url(#linear-gradient-24);}.cls-34{fill:url(#linear-gradient-25);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1879.25,
    y1: 1020.53,
    x2: 1901.66,
    y2: 1213.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1337.53,
    y1: 1222.5,
    x2: 953.74,
    y2: 2161.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1265.71,
    y1: 2056.01,
    x2: 470.71,
    y2: 3221.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2210.95,
    y1: 2134.17,
    x2: 1628.41,
    y2: 2319.21,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1234.9,
    y1: 1180.56,
    x2: 851.11,
    y2: 2119.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -3511.24,
    y1: 3174.47,
    x2: -3299.73,
    y2: 3174.47,
    gradientTransform: "matrix(-1, 0, 0, 1, -688.47, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -3511.25,
    y1: 3133.02,
    x2: -3305.7,
    y2: 3133.02,
    gradientTransform: "matrix(-1, 0, 0, 1, -688.47, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -3491.71,
    y1: 3075.14,
    x2: -3432.13,
    y2: 3075.14,
    gradientTransform: "matrix(-1, 0, 0, 1, -688.47, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -3888.76,
    y1: 3226.92,
    x2: -3807.71,
    y2: 3226.92,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -3888.18,
    y1: 3146.26,
    x2: -3769.2,
    y2: 3146.26,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -3826.33,
    y1: 3044.07,
    x2: -3755.13,
    y2: 3044.07,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2980.5,
    y1: 3236.63,
    x2: 2733.77,
    y2: 2140.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 3003.08,
    y1: 1969.59,
    x2: 2639.85,
    y2: 2538.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cb236d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c246d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -2846.97,
    y1: 1544.26,
    x2: -3128.97,
    y2: 1911.14,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 3607.9,
    y1: 1418.98,
    x2: 2799.19,
    y2: 1843.9,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2563.98,
    y1: 1776.36,
    x2: 2605.48,
    y2: 1776.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -3475.55,
    y1: 1781.38,
    x2: -3444.7,
    y2: 1619.41,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -3392.07,
    y1: 1484.21,
    x2: -3568.1,
    y2: 1618.9,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -3515.99,
    y1: 1377.57,
    x2: -3352.04,
    y2: 1588.64,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -3413.9,
    y1: 1455.68,
    x2: -3589.93,
    y2: 1590.36,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2079.93,
    y1: 1515.38,
    x2: 2149.13,
    y2: 1515.38,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -3310.7,
    y1: 1896.44,
    x2: -3433.91,
    y2: 2081.25,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1036.52,
    y1: 2228.45,
    x2: 758.18,
    y2: 2304.73,
    gradientTransform: "translate(1692.8 -55.03) rotate(-2.83)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 726.44,
    y1: 1941.93,
    x2: 530.11,
    y2: 2149.44,
    gradientTransform: "translate(1734.27)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 607.39,
    y1: 1993.79,
    x2: 518.64,
    y2: 2127.44,
    gradientTransform: "translate(2404.85 -75.23) rotate(18.24)",
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3124.13,2377.68c-294.76,657-1047.28,928.24-1632.15,869.52-159.69-16-481-48.28-728.08-290.26-474.52-464.72-383.54-1417.16,88.15-1970.6C912.8,915.06,1333,437.78,1974.46,455.48c469.65,13,794.71,284.07,834.23,317.83,49.91,42.64,159.88,143.83,257.8,303C3296.57,1450.37,3308.33,1967.12,3124.13,2377.68Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M631.26,2909.84a44.62,44.62,0,0,0,44.52,44.47H3083a44.62,44.62,0,0,0,44.52-44.47l20-1383.38c0-24.46-28.82-72.21-81.63-68.62L713.31,1397A112.2,112.2,0,0,0,598.2,1511.7Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M675.21,2867.17a42.24,42.24,0,0,0,42.12,42.12H3025a42.24,42.24,0,0,0,42.12-42.12L3086,1611.33c-2.23-75.57-68.48-102.74-108.65-101.13L722.56,1449.71a78.83,78.83,0,0,0-80.88,80.67Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3042.15,2270.56h-.09a6.17,6.17,0,0,1-6.08-6.27l1.49-101.84a6.17,6.17,0,0,1,6.17-6.08h.09a6.17,6.17,0,0,1,6.08,6.26l-1.49,101.85A6.17,6.17,0,0,1,3042.15,2270.56Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3045.82,2021h-.09a6.18,6.18,0,0,1-6.09-6.26l5.73-390.08c-.11-23.17-7.14-41.67-20.91-54.86-25.69-24.62-66.49-23.36-68.21-23.28l-720.67-19.33a6.16,6.16,0,0,1-6-6.33,5.91,5.91,0,0,1,6.34-6l720.25,19.33c4.48-.27,47.92-1,76.84,26.7,16.28,15.59,24.59,37.07,24.71,63.83L3052,2014.9A6.17,6.17,0,0,1,3045.82,2021Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 435.98,
    y: 2947.6,
    width: 2838.05,
    height: 121.55,
    rx: 5.65,
    transform: "translate(3274.02 5561.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2552.66,785.4l-1443.93-8.84a82.65,82.65,0,0,0-83.06,86.74L1125,2914.78H2731.83l89.22-1832.89Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2612.7,1073.11A82.66,82.66,0,0,1,2533.21,984l15.48-195.89,272.64,292.59Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1350.83,2088c200.17-3.24,968.54-16.5,1162.56-19.85,24.48-.42,44.6,14.41,44.47,32.73h0c-.12,17.44-18.66,31.63-42,32.11L1354.07,2157c-22.38.47-41.62-11.91-44.38-28.55l-.7-4.2C1305.84,2105.24,1325.24,2088.39,1350.83,2088Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1336.82,2291.65h0c3.37,4.28,9.55,6.9,16.19,6.84l797.71-7.33c10-.09,18.07-6.16,18.13-13.66l.28-39.35c0-7.82-8.58-14.14-19-13.92l-775.54,16.21C1340,2241.16,1319.28,2269.31,1336.82,2291.65Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1347,2444c200.16-3.24,968.53-16.5,1162.56-19.85,24.47-.42,44.59,14.4,44.46,32.73h0c-.12,17.44-18.65,31.62-41.95,32.11L1350.21,2513c-22.38.47-41.61-11.91-44.37-28.55l-.7-4.21C1302,2461.23,1321.38,2444.38,1347,2444Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1333,2647.63h0c3.37,4.29,9.55,6.9,16.18,6.84l797.71-7.32c10-.09,18.08-6.16,18.13-13.66l.28-39.36c.05-7.82-8.58-14.13-19-13.91l-775.54,16.21C1336.17,2597.15,1315.42,2625.3,1333,2647.63Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2269.39,1248.62c-4.24-5.21-10.88-7.37-17.93-7.22l-641.58,13.45-16.21-51.48a16.7,16.7,0,0,0-16.63-11.56l-88.09,2.31c-9.44.25-17.09,6.82-17.09,16.25s7.65,15.61,17.09,15.39l75.28-1.78,136.22,435.26a18,18,0,0,0,17,12.47l450.33,6c10.57.15,19.15-6.49,19.15-16.48s-8.58-16.83-19.15-17l-437.19-4.71-35.08-113,480.43.73a22.25,22.25,0,0,0,21.26-15.35L2273,1266.81A19.31,19.31,0,0,0,2269.39,1248.62Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1783.29,1698.55c-37-.57-67,28.27-67,64.29s30,66.11,67,67.08c37.28,1,67.77-27.84,67.77-64.26S1820.57,1699.13,1783.29,1698.55Zm0,96.34c-17.32-.4-31.37-14.45-31.37-31.31s14-30.31,31.37-30,31.53,14.36,31.53,31.31S1800.66,1795.3,1783.29,1794.89Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2083.49,1703.22c-38.89-.6-70.35,28.93-70.35,65.82s31.46,67.75,70.35,68.77c39.12,1,71.14-28.49,71.14-65.81S2122.61,1703.83,2083.49,1703.22Zm0,98.7c-18.18-.43-32.93-14.82-32.93-32.09s14.75-31,32.93-30.72,33.1,14.74,33.1,32.1S2101.71,1802.35,2083.49,1801.92Z",
    transform: "translate(-435.98 -455)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1902,1991.1c-303.78,0-550.91-247.14-550.91-550.91S1598.18,889.28,1902,889.28s550.91,247.13,550.91,550.91S2205.73,1991.1,1902,1991.1Zm0-1074.41c-288.66,0-523.5,234.84-523.5,523.5s234.84,523.5,523.5,523.5,523.5-234.84,523.5-523.5S2190.62,916.69,1902,916.69Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1909.18,1508.76a22.53,22.53,0,0,1-20.82-10.47l-73.95-118.75c-6.93-11.12-3.2-26.37,8.34-34s26.47-4.86,33.4,6.26l51.28,82.43,67.67-137.82c6.07-12.37,20.66-18,32.58-12.68s16.65,19.73,10.59,32.09L1930.82,1494a26.36,26.36,0,0,1-20.78,14.66Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M872,1951.62a8.56,8.56,0,0,1-8.56-8.3c-.09-3.12-2.07-77.16,19.73-156.24,29.36-106.5,88.25-169.63,170.31-182.54,40.2-6.34,76,3.16,106.49,28.2,99.26,81.65,108.7,300.71,109.06,310a8.57,8.57,0,1,1-17.12.65c-.09-2.19-9.51-220.67-102.84-297.42-26.51-21.79-57.77-30-92.93-24.5C873.8,1650.17,880.51,1939.87,880.6,1942.8a8.56,8.56,0,0,1-8.3,8.82Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M511.18,2889.6l147.2-1015.11,553-9.3L1389.6,2946H559.06C529.52,2946,506.87,2919.33,511.18,2889.6Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1318.76,1874.49l-107.39-9.3L1389.6,2946h106.62c21.62,0,37.77-20.2,33.37-41.73Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1141.67,1949.3a8.57,8.57,0,0,1-8.56-8.24c-.08-2.2-9.51-220.68-102.84-297.42-26.5-21.79-57.76-30-92.92-24.5-182.23,28.68-175.66,318.41-175.58,321.33a8.56,8.56,0,1,1-17.12.52c-.1-3.11-2.08-77.16,19.73-156.23,29.36-106.51,88.25-169.63,170.31-182.55,40.2-6.33,76,3.16,106.48,28.21,99.27,81.65,108.71,300.7,109.06,310a8.55,8.55,0,0,1-8.23,8.88Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2617.23,3164.24c36.24,3.13,99.12,8.22,148.7,10.4,29.8,1.31,47-1.61,56.84-5.56,0,1.11-.05,2.17-.09,3.14a10.25,10.25,0,0,1-9.74,9.69c-93.68,5.23-168.19,1.81-194.71.19a7.3,7.3,0,0,1-5.95-11A61.56,61.56,0,0,1,2617.23,3164.24Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2765.93,3174.64c-49.58-2.18-112.46-7.27-148.7-10.4,35.63-43.71,148.7-73.17,148.7-73.17h31.94c22,31.66,25.14,61.81,24.9,78C2812.89,3173,2795.73,3176,2765.93,3174.64Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2803.24,3038.94l-3,59.14a13.52,13.52,0,0,1-11.54,12.7,52.53,52.53,0,0,1-24-2,16,16,0,0,1-10.74-12.28l-10.33-57.57Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M3173.9,3232.46c15.71-2.83,22.82-13.38,25.81-24.66l.05.3a28.11,28.11,0,0,1-13.76,30.1c-12.95,7.08-27.11,8.29-38.1,7.71a35.24,35.24,0,0,1-28.57-17l-.09-.16C3131.08,3236.29,3147.7,3237.19,3173.9,3232.46Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M3099.81,3057.16h26.34c40.12-1.06,65.31,108.29,73.56,150.64-3,11.28-10.1,21.83-25.81,24.66-26.2,4.73-42.82,3.83-54.66-3.74-21.67-36.86-32.42-90.84-37.58-122.35C3075.78,3070.54,3099.81,3057.16,3099.81,3057.16Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3122.77,3002.26l14.62,58.17a15.79,15.79,0,0,1-8.21,17.89c-8.18,4.2-19.7,8.61-30.29,7.34a13.2,13.2,0,0,1-10.76-8.8l-21.47-61.2Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2608.31,2236.18S2739,3053.11,2736.85,3057.6c0,0,36.09,16.41,75.45,2.1,0,0-11.82-436.71-39.52-604.16,0,0,223,390.33,293.88,584.83,0,0,36.94-4.41,67.52-24.53,0,0-240.15-702.58-304.23-796.16Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2767.57,2451.29a3.86,3.86,0,0,0,3.26-5.91l-48.83-78a3.91,3.91,0,0,0-2.51-1.74l-35.95-7.23A3.86,3.86,0,0,0,2682,2366l34.31,6.9,48,76.6A3.86,3.86,0,0,0,2767.57,2451.29Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2008.57,1436.22s88.19,19.45,141.83,44.22a49,49,0,0,1,24,24.12c16,35.14,64,123.26,157.12,165.31-13.41,17.79-35,54.8-44.39,117-55.91-41.61-104.17-111.1-127.34-225.06,0,0-17.65,9.59-39.66-1.1-11.63-5.65-25-13.66-35.13-20a46,46,0,0,1-20.43-27.43c-3.84-15-1.58-28.28-1.58-42.48l-45.33-14S2004,1451.65,2008.57,1436.22Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2287.12,1786.87c9.4-62.2,31-99.21,44.39-117,57.82,26.13,133,34.48,228.82,1.29a101.85,101.85,0,0,1,27.37-5.4c51-3,219-8.45,358.06,37.49a108,108,0,0,1,65.17,59.33c37.61,86.31,98.5,282.87-70.54,382.11a420.31,420.31,0,0,0-40.79-77.21c27.22-45.91,35.28-108.63-13-190.3-35.22,95.12-51.75,233.9-55.2,295.32a132,132,0,0,0,10.34,59.07l.87,2a7,7,0,0,1-4.91,9.55c-95.16,21.37-194.14,15.57-223.71,13.12a12.2,12.2,0,0,1-10.88-9.31c-46.27-195-46.38-328-35-412.08C2524.74,1844.57,2392.37,1865.21,2287.12,1786.87Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M2567.84,1840.14a3.88,3.88,0,0,0,3.83-3.36c10.86-82.09,33-117.92,33.22-118.27a3.86,3.86,0,0,0-6.52-4.14c-.95,1.49-23.23,37.36-34.36,121.4a3.86,3.86,0,0,0,3.32,4.33A4.56,4.56,0,0,0,2567.84,1840.14Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2802.69,1552.17s9.63,101.79,18.11,131.9a10.31,10.31,0,0,1-4.85,11.76c-14.39,8.22-48.89,21.63-96.09-1.5a21.43,21.43,0,0,1-11.89-20.16l4.16-98.36Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2710.05,1422s-30.79,70.73-32.86,107.86-10.06,61.22,32.86,68.69,79.09-13.91,98.69-50.89c0,0,30.69-57,23.81-80.32S2710.05,1422,2710.05,1422Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2794.07,1521l-2.45-1.07a5.91,5.91,0,0,1-2.88-8.1c6.06-11.69,17.86-38.5,2.61-44.75-19.64-8.06-97.47-23.93-114.26-51.54-16.14-26.54-1.84-60.8,19.65-70.54a2.94,2.94,0,0,1,3.87,1.26l1.79,3.39a2.92,2.92,0,0,0,5.38-.56,2.91,2.91,0,0,1,5.26-.75c5.16,8.26,19.09,21.66,56.36,28.53,52.95,9.78,88,31.21,88.84,67.8a2.92,2.92,0,0,0,4.51,2.41c3.91-2.38,10.17-3.5,18.53,3.53,14.55,12.23,8.6,44-23.29,70a2.9,2.9,0,0,0,.14,4.67c5.78,3.76,14.4,12.72-7.93,24.65-23.09,12.35-40.34,11.33-47,10.24a2.9,2.9,0,0,1-2.35-3.51l7.08-32.16a2.91,2.91,0,0,0-2.84-3.55Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2792.73,1527.81s11.75-45.18,32-32.52-10.51,50.63-26.8,52.32Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M2136.26,1551.3a3.8,3.8,0,0,0,2.43-.87,3.86,3.86,0,0,0,.56-5.43c-3.34-4.1-32.93-40.28-44.33-46.72-4.15-2.35-6.62-4.77-7.15-7a5.71,5.71,0,0,1,.52-3.63l34.77,7,19.7,16.9a3.86,3.86,0,0,0,5-5.86l-20.47-17.56a3.94,3.94,0,0,0-1.75-.86l-38.5-7.71a3.85,3.85,0,0,0-4,1.63c-2.82,4.18-3.75,8.08-2.85,11.89,1.06,4.51,4.61,8.42,10.86,12,8.58,4.84,33.33,34,42.14,44.88A3.88,3.88,0,0,0,2136.26,1551.3Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2794.23,2193.61l-136.11,1.68,47.64-44.84a35.55,35.55,0,0,1,43.58-4.08,103,103,0,0,1,24.2,21.56s84.9-31,126.06-100.45a420.31,420.31,0,0,1,40.79,77.21C2903.5,2166.35,2855.67,2183.38,2794.23,2193.61Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2779.56,2211.16c-.26,0-.52,0-.79,0l-345.49-.37a15.3,15.3,0,1,1,0-30.6l345.49.37a15.3,15.3,0,0,1,.76,30.58Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2122.7,1900.79h287.73a54.87,54.87,0,0,1,49.59,31.12L2593,2211H2235.47a33.31,33.31,0,0,1-31-20.86l-103.15-258.24C2095.37,1917,2106.48,1900.79,2122.7,1900.79Z",
    transform: "translate(-435.98 -455)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 2303.83,
    cy: 2050.75,
    rx: 22.65,
    ry: 36.5,
    transform: "translate(-962.15 369.24) rotate(-18.24)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInC);
export default __webpack_public_path__ + "static/media/in-c.a2ccb36c1012f680e99d993fc121cbe9.svg";
export { ForwardRef as ReactComponent };